

// import tableplusIcon from '../assets/tableplus.svg'


function AboutMe() {
  return (
    <div className="about-me-container" id="aboutme">
      <div class="card about-me-card">
  <div class="card-body about-me-card-body">
    <h1 class="card-title">About Me </h1>
    <p class="card-text">Hi, my name is Aromi. I am a full stack developer from London.</p>
    <p class="card-text">My previous role as an advisor enabled me to develop skills in negotiations, 
        policy developement, strategy, project management and delivery.
        Over the course of my time at my previous role, I was instrumental in the signing of 2 trade deals.</p>
    <p class="card-text"> Moving into web development was a natural progression for me as I have always been interested in technology and self taught in my spare time.
        I wanted to immerse myself more into software development, 
        so I enrolled in the Software Engineering Immersive course at General Assembly, 
        which has been a great way for me to combine the skills obtained at my previous role and technical skills.</p>
  </div>
</div>
    </div>
  );
}

export default AboutMe;
